// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__43zDa","header":"ReportDetails_header__mMYdZ","title":"ReportDetails_title__21DSj","left":"ReportDetails_left__3Rvz_"};